import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import Datepicker from '../../../common/datePicker'
import { Box, Button } from '@mui/material'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import {
  getBranchListAndCityList,
  getCargoRoleRightsConfigListAll,
  updateAlertError,
  updateModal,
} from '../../../../store/common/common_action'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { getCargoUnloadingTblData, getDispatchedVehicleData } from '../../../../store/reports/reports_action'
import moment from 'moment'
import * as urlValue from '../oldReportsUrls'
import { cargoUnloadingTblDefs, headerData } from './constants'
import { API_CACHE_DURATION, PARENT_COMPANY_MODE, urls, xlCol } from '../../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import { GetRequest } from '../../../common/api'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../analysisReport/pdfAutotable'
import { GT_COMPANY_ID } from '../../../../helper/companyIdhardcode'
import { getDecryptedReportParams } from '../../../common/loginDecode'
const CargoUnloadingReport = (props) => {
  const {
    data: { common, reports },
    updateAlertError,
    getCargoRoleRightsConfigListAll,
    getCargoUnloadingTblData,
    getDispatchedVehicleData,
    getBranchListAndCityList,
  } = props
  const { loginData: reduxLoginData = {}, roleRights, companySettings } = common
  const {parentCompnayData} = common
  const OwnparentCompnayData = parentCompnayData.length ? parentCompnayData[PARENT_COMPANY_MODE] : {}
  const { ParentCompanyID } = OwnparentCompnayData
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const urlLoginData = React.useMemo(() => {
    if (!searchParams.get('C')) {
      return null
    }
    return {
      intCompanyID: Number(searchParams.get('C') || 0),
      intBranchCityID: Number(searchParams.get('CT') || 0),
      strCityName: searchParams.get('CTN') || '',
      intUserID: Number(searchParams.get('U') || 0),
      intBranchID: Number(searchParams.get('B') || 0),
      strCompanyName: searchParams.get('CN') || '',
      strUserName: searchParams.get('UN') || '',
      strBranchName: searchParams.get('BN') || '',
      IsBranchAdmin: Number(searchParams.get('IBA') || 0),
      IsMTPLAdmin: Number(searchParams.get('IMPTLA') || 0),
      IsAdmin: Number(searchParams.get('IA') || 0),
    }
  }, [searchParams])
  const tokenData = useToken() || {}
  let loginData = tokenData?.loginData ?? reduxLoginData
  const roleRightsData = roleRights?.Table1?.[0] || roleRights || {}
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights } = {
    ...roleRightsData,
  }
  let isFromUrl = false
  if ((!loginData || isEmpty(loginData)) && urlLoginData) {
    loginData = urlLoginData
    AllowViewAllBranchOfCityReport = Number(searchParams.get('AllowViewAllBranchOfCityReport') || 0)
    AllowViewAllBranchReport = Number(searchParams.get('AllowViewAllBranchReport') || 0)
    AllowBranchInchargeRights = Number(searchParams.get('AllowBranchInchargeRights') || 0)
    isFromUrl = true
  }
  const intCompanyID = loginData?.intCompanyID || 0
  const allownFormatLR = companySettings?.[0]?.UseFormattedLRinReports ?? Number(searchParams.get('UseFormattedLRinReports') || 1)
  const { cargoUnloadingTableData, dispatchedVehicleNoData } = reports
  const { IsAdmin, IsBranchAdmin, IsMTPLAdmin } = loginData || {}
  const [showTable, setShowTable] = useState(false)
  const [allowViewAll, setAllowViewAll] = useState(0)
  const [branchList, setBranchList] = useState([])
  const [vehicleList, setVehicleList] = useState([])
  const [companyName, setCompanyName] = useState('')
  const [companyDropdown, setCompanyDropdown] = useState([])
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), branchName: '', vehicleNo: '' })
  const [reportReset, setReportReset] = useState(false)
  const [columns, setColumns] = useState([])
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const reportName = 'Cargo Unloading Report'
  useEffect(() => {
    focusElemnt('cuFromDate')
  }, [])
  useEffect(() => {
    if (intCompanyID) {
      if (!isFromUrl) {
        getCargoRoleRightsConfigListAll(loginData, true, API_CACHE_DURATION)
      }
      const obj = {
        intUserID: 0,
        intCompanyID: intCompanyID,
        intBranchID: 0,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: Number(AllowViewAllBranchReport) === 1 ? 0 : loginData?.intBranchCityID,
        intIsActive: -1,
      }
      getBranchListAndCityList(obj)
        .then((res) => {
          if (res.status === 'Success') {
            setBranchList(res?.Data?.Table)
            let newData = res?.Data?.Table?.filter((val) => val?.BranchID === loginData?.intBranchID)?.[0]
            setFilters((prev) => ({
              ...prev,
              branchName: newData,
            }))
          } else {
            setBranchList([])
          }
        })
        .catch((err) => {
          setBranchList([])
        })
    }
  }, [intCompanyID, AllowViewAllBranchReport, isFromUrl])
  useEffect(() => {
    if (dispatchedVehicleNoData?.length > 0) {
      setVehicleList(dispatchedVehicleNoData)
      setFilters((prev) => ({
        ...prev,
        vehicleNo: dispatchedVehicleNoData?.[0],
      }))
    } else {
      setReportReset(false)
      setTimeout(() => {
        setReportReset(true)
      }, 100)
      setVehicleList([])
      setFilters((prev) => ({
        ...prev,
        vehicleNo: '',
      }))
    }
  }, [dispatchedVehicleNoData])

  useEffect(() => {
    if (!isEmpty(loginData) && filters?.branchName !== '' && filters?.fromDate !== '') {
      let body = {
        CompanyID: intCompanyID,
        DestinationBranchID: filters?.branchName?.BranchID,
        DispatchedDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
      }
      getDispatchedVehicleData(body)
    }
  }, [filters?.branchName, filters?.fromDate])
  useEffect(() => {
    if (IsAdmin || IsBranchAdmin || IsMTPLAdmin || Number(AllowViewAllBranchReport) === 1 || Number(AllowBranchInchargeRights) === 1) {
      setAllowViewAll(1)
    } else {
      setAllowViewAll(0)
    }
  }, [loginData, IsAdmin, IsBranchAdmin, IsMTPLAdmin, AllowViewAllBranchReport, AllowBranchInchargeRights])
  useEffect(() => {
    if (intCompanyID) {
      var company = [{ id: intCompanyID, name: loginData.strCompanyName }]
      setCompanyDropdown(company)
      setCompanyName(loginData.strCompanyName)
    }
  }, [intCompanyID])
  useEffect(() => {
    const baseCols = cargoUnloadingTblDefs(intCompanyID)
    if (allownFormatLR === 1 || allownFormatLR === 0) {
      setColumns(baseCols)
    } else if (allownFormatLR === 2) {
      let newCols = [...baseCols]
      newCols[0].header = 'Formatted LR'
      newCols[0].feild = 'FormattedLRNO'
      newCols[0].weight=30
      newCols[0].xlCol=xlCol
      setColumns(newCols)
    } else if (allownFormatLR === 3) {
      let newCols = [...baseCols]
      const newObject = {
        header: 'Formatted LRNO',
        feild: 'FormattedLRNO',
        xlCol: xlCol,
        weight:30,
        headerSx: { minWidth: '11.102%', textAlign: 'left' },
      }
      newCols.splice(1, 0, newObject)
      setColumns(newCols)
    } else {
      setColumns(baseCols)
    }
  }, [allownFormatLR, intCompanyID])
  const FilterHeader={
    dispatchDate:moment(filters?.fromDate)?.format('YYYY-MM-DD'),
    branch:filters?.branchName?.BranchName,
    vehicleNo:filters?.vehicleNo?.VehicleNo,
    dataType: 'entry',
  }
  const headers = columns.map((col) => ({...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
    dataType: 'header',
  }))
 const groupData = (arr) => {
   let totalRow = {
     isTotalRow: true,
     dataType: 'total',
     Receiver: 'TOTAL',
     NOP: 0,
     CHARGEDWEIGHT: 0,
     FREIGHT: 0,
     NETAMOUNT: 0,
   }

   arr.forEach((item) => {
     totalRow.NOP += Number(item?.NOP || 0)
     totalRow.CHARGEDWEIGHT += Number(item?.CHARGEDWEIGHT || 0)
     totalRow.FREIGHT += Number(item?.FREIGHT || 0)
     totalRow.NETAMOUNT += Number(item?.NETAMOUNT || 0)
   })

   // return original data + total row
   return [...arr, totalRow]
 }

  const handleClick1 = (isPdf = false) => {
    if (filters?.fromDate === '' || filters?.branchName === '' || filters?.vehicleNo === '') {
      setAlert({ show: true, msg: 'Please Select The Filter Options', nextId: '' })
      return
    }
    setLoader(true)
    let body = {
      CompanyID: intCompanyID,
      BranchID: filters?.branchName?.BranchID,
      Date: moment(filters?.fromDate)?.format('YYYY-MM-DD'),
      VehicleNo: filters?.vehicleNo?.VehicleNo,
      loginID: loginData?.intUserID,
      AllowViewAllReport: allowViewAll,
    }
    GetRequest(urls.getCargoUnloadingRptTblData, body)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const updatedData = res?.Data?.Table?.map((item) => ({ ...item, dataType: 'entry' }))
        const data = groupData(updatedData)
        const reportPayload = {
          reportName,
          criteriaHeaders: headerData,
          criteriaData: [FilterHeader],
          tableData: data,
          mainHeader: headers,
          isShowManageColumn: false,
          manageColumnID: '',
          hideHeader: false,
          showColumnBorders: true,
          isIncreFontSize: [intCompanyID, ParentCompanyID].includes(GT_COMPANY_ID) ? 2 : 1,
        }
        if (isPdf === true) {
          downloadPDF({
            reportName,
            criteriaHeaders: headerData,
            criteriaData: [FilterHeader],
            tableData: data,
            visibleColumns: headers,
            loginData,
            hideHeader: false,
            showColumnBorders: true,
          })
          return
        }
        const rid = Date.now().toString()
        if (!window.generatedReports) {
          window.generatedReports = {}
        }
        window.generatedReports[rid] = reportPayload
        window.open(`/view-report?rid=${rid}`, '_blank')
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleClick2 = () => {
    if (filters?.fromDate === '' || filters?.branchName === '' || filters?.vehicleNo === '') {
      updateAlertError({ show: true, msg: 'Please Select The Filter Options ', nextId: 'cuFromDate' })
    } else {
      let url = urlValue.cargoUnloadingReport
      const urlData = urlValue.cargoUnloadingParams
      urlData.chk = loginData?.BusCrsCheckSum
      urlData.date = moment(filters?.fromDate)?.format('YYYY-MM-DD')
      urlData.intBranchID = filters?.branchName?.BranchID
      urlData.VehicleNo = filters?.vehicleNo?.VehicleNo
      urlData.AllowViewAllReport = allowViewAll
      urlData.intAllowExportToExcel = 1

      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const dataValues = {
    roleRights,
    loginData,
    filters,
    cargoUnloadingTableData,
    columns,
    allownFormatLR,
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <ReportHeading reportName={'Cargo Unloading'} />}
        <Box sx={{ ...sx.reportFlex, flexWrap: isFromUrl ? 'wrap' : 'nowrap', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && <><Item sx={sx.itemsxGrow} style={{ width: '18.59%' }}>
            <DropDownOA
              id={'prtyBkngCompanyName'}
              label={'Company Name'}
              width="100%"
              searchPlaceholder={'Search Company Name'}
              disabled
              // onSelect={(e) => { }}
              nextId="prtyBkngGoBtn"
              prevId=""
              // resetFlag={resetFilter}
              data={companyDropdown || []}
              defaultvalue={companyName || ''}
              value={companyName || ''}
              dataKey={`name`}
              idKey={`id`}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, width: '5%' }}>
            <Button
              variant="contained"
              id="prtyBkngGoBtnOne"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              //onClick={()=>{}}
              disabled
            >
              GO
            </Button>
          </Item></>}
          <Item sx={sx.itemsxGrow} style={{ width: isFromUrl ? 'auto' : '15.8%' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'From Dispatch Date'}
              label={'Dispatch Date'}
              id="cuFromDate"
              value={filters?.fromDate}
              dateChange={(date) => {
                setFilters((prev) => ({
                  ...prev,
                  fromDate: date,
                }))
                setShowTable(false)
                focusElemnt('cuBranchName')
              }}
              width="100%"
            />
          </Item>

          <Item sx={sx.itemsxGrow} style={{ width: isFromUrl ? 'auto' : '17.8%' }}>
            <DropDownOA
              id="cuBranchName"
              label={'Select Branch Name'}
              searchPlaceholder={`Search Branch Name`}
              defaultvalue={filters?.branchName?.BranchName || ''}
              value={filters?.branchName?.BranchName || ''}
              data={branchList || []}
              idKey={'BranchID'}
              dataKey={`BranchName`}
              width="100%"
              disabled={allowViewAll === 0 && Number(AllowViewAllBranchOfCityReport) === 0}
              onSelect={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  branchName: val,
                }))
                setShowTable(false)
              }}
              nextId={'cuVehicleNO'}
              prevId={'cuFromDate'}
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: isFromUrl ? 'auto' : '17.8%' }}>
            <DropDownOA
              id="cuVehicleNO"
              label={'Select Vehicle No.'}
              searchPlaceholder={`Search Vehicle No.`}
              defaultvalue={filters?.vehicleNo?.VehicleNo || ''}
              value={filters?.vehicleNo?.VehicleNo || ''}
              data={vehicleList || []}
              dataKey={`VehicleNo`}
              idKey={`VehicleID`}
              width="100%"
              resetFlag={reportReset}
              onSelect={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  vehicleNo: val,
                }))
                setShowTable(false)
              }}
              nextId={isFromUrl ? 'cuDownloadPdfBtn' : 'cu-SplitButton'}
              prevId={'cuBranchName'}
            />
          </Item>
          {isFromUrl ? (
            <Button
              variant="contained"
              sx={{ width: '100%', height: '40px', marginBottom: '10px' }}
              className="btn btn-primary"
              onClick={() => handleClick1(true)}
              id="cuDownloadPdfBtn"
            >
              DOWNLOAD PDF
            </Button>
          ) : (
          <Item
            sx={sx.itemsx}
            tabIndex={0}
            id="cuFromDate"
            onKeyDown={(e) =>
              navigation3(
                e,
                showTable ? (roleRights?.Table1[0]?.AllowExportExcel === 1 ? 'cu-test-table-xls-button' : 'exportAsPdfBtn') : 'cuFromDate',
                'cuVehicleNO',
                () => {
                  handleClick1()
                }
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              onClick1={() => {
                handleClick1()
              }}
              onClick2={() => {
                handleClick2()
              }}
              hideToggle={[intCompanyID, ParentCompanyID].includes(GT_COMPANY_ID) ? true : false}
              id1={'cu-SplitButton'}
            />
          </Item>
          )}
        </Box>
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  getBranchListAndCityList,
  getCargoRoleRightsConfigListAll,
  getCargoUnloadingTblData,
  getDispatchedVehicleData,
}
export default connect(mapStateToProps, mapDispatchToProps)(CargoUnloadingReport)
